export const RECEIPT_PRINT_TARGET_CLOUD = "CLOUD" as const
export const RECEIPT_PRINT_TARGET_LOCAL = "LOCAL" as const
export const CLOUD_PRINT_SUBMITTED_MESSAGE = "已发送至云打印机"

export type ReceiptPrintTargetType =
  | typeof RECEIPT_PRINT_TARGET_CLOUD
  | typeof RECEIPT_PRINT_TARGET_LOCAL

export interface ReceiptPrintTargetSetting {
  receiptPrintTargetType?: null | string
  receiptPrinterRelId?: null | number
}

export interface NormalizedReceiptPrintTarget {
  receiptPrintTargetType: ReceiptPrintTargetType
  receiptPrinterRelId?: number
}

export interface ReceiptPrintRunnerOptions {
  setting?: null | ReceiptPrintTargetSetting
  cloudAvailable: boolean
  localAvailable?: boolean
  printCloud: (printerRelId?: number) => Promise<boolean>
  printLocal: () => Promise<boolean>
}

export function normalizeReceiptPrintTarget(setting?: null | ReceiptPrintTargetSetting): NormalizedReceiptPrintTarget {
  if (setting?.receiptPrintTargetType === RECEIPT_PRINT_TARGET_LOCAL) {
    return {
      receiptPrintTargetType: RECEIPT_PRINT_TARGET_LOCAL,
      receiptPrinterRelId: undefined,
    }
  }

  return {
    receiptPrintTargetType: RECEIPT_PRINT_TARGET_CLOUD,
    receiptPrinterRelId: typeof setting?.receiptPrinterRelId === "number" ? setting.receiptPrinterRelId : undefined,
  }
}

export function isLocalReceiptPrintTarget(setting?: ReceiptPrintTargetSetting | null) {
  return normalizeReceiptPrintTarget(setting).receiptPrintTargetType === RECEIPT_PRINT_TARGET_LOCAL
}

export async function runReceiptPrintByTarget(options: ReceiptPrintRunnerOptions) {
  const target = normalizeReceiptPrintTarget(options.setting)
  const localAvailable = options.localAvailable ?? true

  if (target.receiptPrintTargetType === RECEIPT_PRINT_TARGET_LOCAL) {
    return localAvailable ? options.printLocal() : false
  }

  return options.cloudAvailable ? options.printCloud(target.receiptPrinterRelId) : false
}
